import { Router } from '@angular/router';
import { PageMetadata } from '@app/router';
import { AccessCode } from '@models';

interface IRestrictedAccessOptions {
    code?: AccessCode;
    page?: PageMetadata;
}

export const restrictedUrlTree = (
    router: Router,
    {
        code,
        page,
    }: IRestrictedAccessOptions = {},
) => {
    return router.createUrlTree(['/restricted-access'], {
        queryParams: {
            target: page ? page.identifier : '',
            reason: code,
        },
        skipLocationChange: true,
    });
};
